export { EloShoppingBagOpenIcon } from './shopping-bag-open-icon'
